document.addEventListener("DOMContentLoaded", function () {
  // Revisar si ya se tomó una decisión
  /*if (!localStorage.getItem("cookieDecision")) {

    // Crear el contenedor del modal
    const modal = document.createElement("div");
    modal.id = "custom-cookie-modal";
    modal.style.position = "fixed";
    modal.style.bottom = "0";
    modal.style.left = "0";
    modal.style.width = "100%";
    modal.style.display = "flex";
    modal.style.justifyContent = "center";
    modal.style.alignItems = "end";
    modal.style.zIndex = "9999";

    // Contenido del modal
    modal.innerHTML = `
      <div class="cookies_new_modal" style="">
      <h2 class="cookies_tittle">Consentimiento para el uso de cookies</h2>
        <p>Nosotros y nuestros partners, incluido Shopify, utilizamos cookies y otras tecnologías para personalizar tu experiencia, mostrarte anuncios y realizar informes y estadísticas, y no utilizaremos cookies ni otras tecnologías para estos fines a menos que las aceptes. Obtén más información en nuestra <a id="shopify-pc__banner__body-policy-link" href="/pages/politica-de-cookies" target="_blank" rel="noopener noreferrer">Política de cookies</a></p>
        <div class="cookie-buttons" style="margin-top:15px;">
          <button id="cookie-accept" >Aceptar</button>
          <button id="cookie-decline">Rechazar</button>
        </div>
      </div>
    `;

    // Agregar al body
    document.body.appendChild(modal);

    // Eventos de los botones
    document.getElementById("cookie-accept").addEventListener("click", function() {
      localStorage.setItem("cookieDecision", "accepted");
      modal.remove();
    });

    document.getElementById("cookie-decline").addEventListener("click", function() {
      localStorage.setItem("cookieDecision", "declined");
      modal.remove();
    });
  }*/
  const cartIcon = document.getElementById("cart-icon-bubble");

  if (cartIcon) {
    cartIcon.addEventListener("click", function (e) {
      e.preventDefault(); // 🚫 Bloquea el enlace /cart
      openCartDrawer();   // 🚀 Llama tu función para abrir el modal
    });
  }
  // ✅ Inyectar el drawer en el body al cargar la página
  const drawerHTML = `
  <div class="ea-sticky-cart-backdrop"></div>
    <div id="cartDrawer" class="cart-drawer">
      <div class="cart-drawer__content">
        <div class="head_cart">
        <h3>Carrito • <span class="count_cart">0</span></h3>
        <button id="closeCartDrawer">✕</button>
        </div>
        <div class="content_center_cart">
        <div id="progreso_free"></div>
        <div id="cartItems"></div>
        <div id="products_recomends"></div>
        </div>
        <div class="cart-drawer__footer">
          <div class="cart_subtotal"><p>Subtotal</p><span class="price_black sub_total_cart">0,00 €</span></div>
          <a href="/checkout" class="btn btn_pagar btn-primary">Ir a pagar</a>
        </div>
      </div>
    </div>

  `;
  document.body.insertAdjacentHTML("beforeend", drawerHTML);

  // ✅ Función para añadir al carrito
  function addToCart(variantId, buttonEl) {
    if (!variantId || !buttonEl) return;

    const originalText = buttonEl.innerHTML;
    buttonEl.disabled = true;
    buttonEl.classList.add("is-loading");
    buttonEl.innerText = "Añadiendo...";

    const formData = new FormData();
    formData.append("id", variantId);
    formData.append("quantity", 1);

    fetch("/cart/add.js", {
      method: "POST",
      body: formData,
      headers: { "X-Requested-With": "XMLHttpRequest" },
    })
      .then((response) => {
        if (!response.ok) throw new Error("Error al añadir al carrito");
        return response.json();
      })
      .then(() => {
        // ✅ Obtener carrito completo
        fetch("/cart.js")
          .then((res) => res.json())
          .then((cart) => {
            renderCartDrawer(cart);
            openCartDrawer();
          });
      })
      .catch((error) => {
        console.error("Error:", error);
        alert("Hubo un problema al añadir el producto.");
      })
      .finally(() => {
        buttonEl.disabled = false;
        buttonEl.classList.remove("is-loading");
        buttonEl.innerHTML = originalText;
      });
  }
  function actualizarBarraEnvioGratis(subtotal) {
  const progresoEl = document.getElementById("progreso_free");
  if (!progresoEl) return;

  // Umbral de envío gratis en céntimos (59€)
  const envioGratisUmbral = 5900;
  const restante = envioGratisUmbral - subtotal;

  // Calculamos progreso
  let progreso = (subtotal / envioGratisUmbral) * 100;
  if (progreso > 100) progreso = 100;

  // Texto dinámico
  let mensaje = "";
  if (restante > 0) {
    mensaje = `¡ ${formatoEuro(restante)} más para envío gratis!`;
  } else {
    mensaje = "¡Envío gratuito desbloqueado!";
  }

  // Renderizamos HTML dentro del div
  progresoEl.innerHTML = `
    <p>${mensaje}</p>
    <div class="progress-bar">
      <div class="progress-bar-fill" style="width: ${progreso}%;"></div>
    </div>
  `;
}

function formatoEuro(valor) {
  // Dividimos entre 100 para obtener los decimales
  let numero = valor / 100;

  // Convertimos al formato europeo con 2 decimales
  return numero.toLocaleString("es-ES", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }) + " €";
}
  // ✅ Renderizar productos dentro del drawer
function renderCartDrawer(cart) {
  const cartItemsEl = document.getElementById("cartItems");
  const cartIconBubble = document.getElementById("cart-icon-bubble");
        let bubble = document.querySelector(".cart-count-bubble");

        // Si hay productos y la burbuja no existe, la creamos
        // If there are items and the bubble doesn't exist, create it
        if (cart.item_count > 0 && !bubble && cartIconBubble) {
          bubble = document.createElement("div");
          bubble.className = "cart-count-bubble";
          bubble.innerHTML = `
          <span aria-hidden="true">${cart.item_count}</span>
          <span class="visually-hidden">${cart.item_count} artículo${
            cart.item_count !== 1 ? "s" : ""
          }</span>
        `;
          cartIconBubble.appendChild(bubble);
        } else if (bubble) {
          // Si existe, solo actualizamos el contenido
          // If it exists, just update the content
          const visibleSpan = bubble.querySelector("span[aria-hidden='true']");
          const hiddenSpan = bubble.querySelector(".visually-hidden");
          if (visibleSpan) visibleSpan.textContent = cart.item_count;
          if (hiddenSpan)
            hiddenSpan.textContent = `${cart.item_count} artículo${
              cart.item_count !== 1 ? "s" : ""
            }`;

          // Si el carrito está vacío, quitamos la burbuja
          // If the cart is empty, remove the bubble
          if (cart.item_count === 0) {
            bubble.remove();
          }
        }
  document.querySelector('.count_cart').textContent = cart.item_count;
  document.querySelector('.sub_total_cart').textContent = formatoEuro(cart.items_subtotal_price);
  cartItemsEl.innerHTML = "";
actualizarBarraEnvioGratis(cart.items_subtotal_price);
if (cart.items.length === 0) {
  // Si no hay productos, mostramos el mensaje
  cartItemsEl.innerHTML = `
    <div class="emptyCartTitle">
      No hay productos en tu carrito… todavía
    </div>
  `;
} else {
  cart.items.forEach((item, index) => {
    const el = document.createElement("div");
    el.className = "cart-item";
    el.innerHTML = `
      <img src="${item.image}" alt="${item.title}">
      <div class="content_more">
        <div class="content_title">
        <a href="${item.url}" class="redire_cart easc-max-2-lines" style="line-height: normal;">${item.product_title}</a>
        <button class="remove-item" data-line="${index + 1}"><i class="delete_ico_cart"><svg height="18" width="18" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path d="M14 3h-3.53a3.07 3.07 0 00-.6-1.65C9.44.82 8.8.5 8 .5s-1.44.32-1.87.85A3.06 3.06 0 005.53 3H2a.5.5 0 000 1h1.25v10c0 .28.22.5.5.5h8.5a.5.5 0 00.5-.5V4H14a.5.5 0 000-1zM6.91 1.98c.23-.29.58-.48 1.09-.48s.85.19 1.09.48c.2.24.3.6.36 1.02h-2.9c.05-.42.17-.78.36-1.02zm4.84 11.52h-7.5V4h7.5v9.5z" fill="currentColor"></path><path d="M6.55 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5zM9.45 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5z" fill="currentColor"></path></svg></i></button>
        </div>
        <div class="content_precio">
        <span class="comparar_precio" id="compar_${item.id}"></span>
        <span class="price_black">${formatoEuro(item.price)}</span>
        </div>
        <div style="display:flex;justify-content: space-between;align-items: end;">
        <div class="quantity-controls">
          <button class="decrease-qty" data-line="${index + 1}" data-qty="${item.quantity}"><svg height="12" width="12" xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-minus" viewBox="0 0 10 2"><path fill="currentColor" fill-rule="evenodd" d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 1 1 0 1H1A.5.5 0 0 1 .5 1" clip-rule="evenodd"></path></svg></button>
          <span class="qty">${item.quantity}</span>
          <button class="increase-qty" data-line="${index + 1}" data-qty="${item.quantity}"><svg height="12" width="12" xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-plus" viewBox="0 0 10 10"><path fill="currentColor" fill-rule="evenodd" d="M1 4.51a.5.5 0 0 0 0 1h3.5l.01 3.5a.5.5 0 0 0 1-.01V5.5l3.5-.01a.5.5 0 0 0-.01-1H5.5L5.49.99a.5.5 0 0 0-1 .01v3.5l-3.5.01z" clip-rule="evenodd"></path></svg></button>
        </div>
        <span class="price_black">${formatoEuro(item.final_line_price)}</span>
        </div>
      </div>
    `;
    cartItemsEl.appendChild(el);
  });
  cargarComparacionesPorHandles(cart.items);
}
  // ✅ Eliminar productos
  document.querySelectorAll(".remove-item").forEach((btn) => {
    btn.addEventListener("click", function () {
      const line = this.getAttribute("data-line");

      fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ line: parseInt(line), quantity: 0 }),
      })
        .then((res) => res.json())
        .then((updatedCart) => {
          renderCartDrawer(updatedCart);
        });
    });
  });

  // ✅ Disminuir cantidad
  document.querySelectorAll(".decrease-qty").forEach((btn) => {
    btn.addEventListener("click", function () {
      const line = parseInt(this.getAttribute("data-line"));
      let qty = parseInt(this.getAttribute("data-qty"));
      if (qty > 1) qty -= 1; // mínimo 1

      fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ line, quantity: qty }),
      })
        .then((res) => res.json())
        .then((updatedCart) => {
          renderCartDrawer(updatedCart);
        });
    });
  });

  // ✅ Aumentar cantidad
  document.querySelectorAll(".increase-qty").forEach((btn) => {
    btn.addEventListener("click", function () {
      const line = parseInt(this.getAttribute("data-line"));
      let qty = parseInt(this.getAttribute("data-qty"));
      qty += 1;

      fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ line, quantity: qty }),
      })
        .then((res) => res.json())
        .then((updatedCart) => {
          renderCartDrawer(updatedCart);
        });
    });
  });
}


  // ✅ Abrir / cerrar drawer
  function openCartDrawer() {
    //document.getElementById("cartDrawer").classList.add("open");
    const drawer = document.getElementById("cartDrawer");
    const backdrop = document.querySelector(".ea-sticky-cart-backdrop");
    if (drawer) {
    drawer.classList.add("open");
    backdrop.classList.add("open");
    // Cargar el carrito actualizado
    fetch("/cart.js")
      .then((res) => res.json())
      .then((cart) => {
        renderCartDrawer(cart); // reutiliza la función que ya tienes
      });
  }
  }
  document.addEventListener("click", function (e) {
    if (e.target.id === "closeCartDrawer") {
      document.getElementById("cartDrawer").classList.remove("open");
      document.querySelector(".ea-sticky-cart-backdrop").classList.remove("open");
    }
    const drawer = document.getElementById("cartDrawer");
  const backdrop = document.querySelector(".ea-sticky-cart-backdrop");
   if (e.target.classList.contains("ea-sticky-cart-backdrop")) {
    drawer.classList.remove("open");
    backdrop.classList.remove("open");
    return;
  }
  });
  function cargarComparacionesPorHandles(items) {
  items.forEach(item => {
    fetch(`/products/${item.handle}.js`)
      .then(res => res.json())
      .then(data => {
        let variant = data.variants.find(v => v.id == item.id);
        if (variant && variant.compare_at_price > variant.price) {
          document.getElementById(`compar_${item.id}`).innerHTML =
            `${formatoEuro(variant.compare_at_price)}`;
        }
      })
      .catch(err => console.error("Error obteniendo producto:", err));
  });
}
async function obtenerProductosPorHandles(handles) {
  const productos = [];

  for (const handle of handles) {
    try {
      const response = await fetch(`/products/${handle}.js`);
      if (!response.ok) throw new Error(`Error al traer producto ${handle}`);
      const data = await response.json();
      productos.push(data);
    } catch (error) {
      console.error("Error:", error);
    }
  }

  return productos;
}
function renderRecomends(handles) {
  obtenerProductosPorHandles(handles).then(products => {
    if (!products || !products.length) return;

    // HTML base del Swiper
    const recomendsHTML = `
    <div style="display: flex;align-items: center;justify-content: space-between;padding: 15px 20px 5px 20px;">
    <p class="tittle_recomend">Te encantarán estos</p>
    <div style="display:flex;" class="naveg_block"> <!-- Botones navegación -->
        <div class="swiper-button-prev"></div>
        <div class="swiper-button-next" style="text-align: end;"></div>
        </div>
    </div>
      <div class="swiper recomendSwiper">
        <div class="swiper-wrapper">
          ${products.map(prod => `
            <div class="swiper-slide">
              <div class="conten_img_recomen">
                <img class="product_relationad" src="${prod.featured_image}" alt="${prod.title}">
              </div>
              <div class="content_recomend">
              <a href="${prod.url}" class="redire_cart easc-max-2-lines">${prod.title}</a>
              <div style="display:flex;align-items: center;gap: 10px;    margin: 2px 0px;">
              <span class="comparar_precio">${formatoEuro(prod.compare_at_price)}</span>
                <span class="price_black">${formatoEuro(prod.price)}</span>
                </div>
                <button type="button" class="btn_add_cart" onclick="addToCart('${prod.variants[0].id}', this)" aria-label="Agregar al carrito">
                Agregar 
              </button>
              </div>
            </div>
          `).join("")}
        </div>
      </div>
    `;

    document.getElementById("products_recomends").innerHTML = recomendsHTML;

    // Inicializar Swiper
    new Swiper(".recomendSwiper", {
      slidesPerView: 1,
      spaceBetween: 15,
      loop: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        500: {
          slidesPerView: 1.5,
          spaceBetween: 15,
        },
      }
    });
  });
}
renderRecomends([
  "wild-stripes-parche-anti-granos-smile-stop-tea-tree",
  "fortalecedor-vitaminado-laq-colours",
  "ico-termometro-digital-rigido-60-segundos-mc-101",
  "newell-repelente-antimosquitos-familiar-sensitive-xl-200ml",
  "tangle-teezer-cepillo-antienredos-ultimate-barbie-edition",
  "cer8-24-parches-antimosquitos-tigre",
  "bee-natural-balsamo-labial-cera-de-abeja-sabor-cereza",
  "cumlaude-ginesens-lube-30-ml",
  "elmex-caries-pasta-duplo",
  "wild-stripes-waterproof-rainbow-20-apositos-resistente-al-agua"
]);

// Expón la función por si necesitas llamarla desde otro script
  window.addToCart = addToCart;

  /*
// Ejemplo de uso
obtenerProductosPorHandles(["reflex-gel-50-gr", "reflex-spray-130-ml-deutsche-version","endolex-25-mg-10-sobres","flogopatch-5-apositos-adhesivos-medicamentosos"]).then(data => {
  console.log(data);
});

async function obtenerProductosPorVariantIds(variantIds) {
  const productos = [];

  for (const variantId of variantIds) {
    try {
      const response = await fetch(`/variants/${variantId}.js`);
      if (!response.ok) throw new Error(`Error al traer variante ${variantId}`);
      const data = await response.json();
      productos.push(data);
    } catch (error) {
      console.error("Error:", error);
    }
  }

  return productos;
}

// Ejemplo de uso
obtenerProductosPorVariantIds([55189213217151, 55188837007743]).then(data => {
  console.log(data); // aquí tienes toda la info de esas variantes
});
*/

});
